import Abort from 'utils/abort'
import { sentryLog } from 'utils/sentryLogging'

interface Options {
  method?: string
  headers?: { [key: string]: string }
  body?: BodyInit
  params?: object
}

const fetchJson = async (url: string, options: Options): Promise<any> => {
  const { method, headers, body, params }: Options = options
  const init: RequestInit = {
    credentials: 'include',
    signal: Abort.getInstance().signal,
  }

  const requestUrl = new URL(url)

  if (method) {
    init.method = method
  }

  if (headers) {
    const requestHeaders = new Headers()

    Object.entries(headers).forEach(([key, value]) => {
      requestHeaders.set(key, value)
    })

    init.headers = requestHeaders
  }

  if (body) {
    init.body = body
  }

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      requestUrl.searchParams.set(key, value)
    })
  }

  let response: any
  let data: any

  try {
    response = await fetch(requestUrl.toString(), init)

    if (!response.ok) {
      throw new Error(
        `Failed to fetch response: ${response.status} ${response.statusText}`
      )
    }

    data = await response.json()

    if (data?.error) {
      throw new Error(data.error?.message || 'Failed to fetch data')
    }

    return data
  } catch (e) {
    const error = e as Error

    sentryLog(error, {
      url: requestUrl.toString(),
      requestConfig: init,
      response,
      responseDataError: data?.error ? { ...data.error } : undefined,
    })

    throw error
  }
}

export default fetchJson
